const financialManageRoute = [
  {
    path: "/financial",
    name: "Financial",
    component: () => import("@/views/financialManage/index.vue"),
    redirect: "/financial/financialmanage",
    meta: {
        activeName: "Financial",
    },
    
    children: [
      {
        path: "financialmanage",
        name: "FinancialManage",
        component: () =>
          import("@/views/financialManage/financialManage.vue"),
        meta: {
          activeName: "Financial",
        },
      },
    ]
  },
];

export default financialManageRoute;
